<template>
    <v-dialog v-model="show" max-width="600px" :persistent="loading" scrollable>
        <v-card class="pa-4">
            <v-card-title>
                Confirmar atendimento
            </v-card-title>
            <v-card-text>
                <v-form ref="formSession">
                    <v-row>
                        <v-col v-if="error_message" cols="12">
                            <v-alert type="error">
                                {{ error_message }}
                            </v-alert>
                        </v-col>
                        <v-col v-if="success_message" cols="12">
                            <v-alert type="success">
                                {{ success_message }}
                            </v-alert>
                        </v-col>
                        <v-col cols="12">
                            <v-row align="center">
                                <v-col>
                                    <v-divider class="bg-primary-blue border-2"></v-divider>
                                </v-col>
                                <v-col cols="auto">
                                    Informações do atendimento atual
                                </v-col>
                                <v-col>
                                    <v-divider class="bg-primary-pink border-2"></v-divider>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="6">
                            <v-text-field
                                v-model="customer_name"
                                label="Cliente"
                                :disabled="true"
                            />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field-money
                                v-model="session_value"
                                label="Valor do atendimento"
                                :properties="{
                                    prefix: 'R$',
                                }"
                                :options="{
                                    locale: 'pt-BR',
                                    length: 11,
                                    precision: 2,
                                    empty: null,
                                }"
                            />
                        </v-col>
                        <v-col v-if="customerData && (customerData.customer_doctor.balance / 100 < session_value)" cols="12">
                            <v-alert dense text type="error" color="error darken-4">O cliente não tem saldo suficiente para este atendimento.<br>Saldo do cliente: {{ (customerData.customer_doctor.balance / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</v-alert>
                        </v-col>
                        <v-col cols="4">
                            <v-menu
                                ref="sessionDate"
                                v-model="show_datepicker_date"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formatDate(session_date)"
                                        label="Data do atendimento"
                                        append-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="[basic_rules.required]"
                                        @input="$event => session_date = formatUsa($event)"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="session_date"
                                    no-title
                                    scrollable
                                    editable
                                    @input="show_datepicker_date = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-menu
                                ref="menuTimePicker"
                                v-model="show_timepicker"
                                :close-on-content-click="false"
                                :return-value.sync="hour_session"
                                transition="scale-transition"
                                offset-y
                                min-width="300px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="hour_session"
                                        label="Hora do atendimento"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="[basic_rules.required]"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="show_timepicker"
                                    v-model="hour_session"
                                    format="24hr"
                                    full-width
                                    @click:minute="$refs.menuTimePicker.save(hour_session)"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="session_duration" label="Duração (em minutos)" type="number" />
                        </v-col>
                        <v-col cols="6">
                            <v-switch
                                v-model="attended"
                                color="primary-blue"
                                label="O cliente compareceu"
                            ></v-switch>
                        </v-col>
                        <v-col cols="6">
                            <v-switch
                                v-model="session_record"
                                color="primary-blue"
                                label="Prontuário montado?"
                            ></v-switch>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="comments" rows="1" label="Observações" />
                        </v-col>
                        <v-col cols="12">
                            <v-textarea v-model="private_note" rows="1" label="Anotações privadas" />
                        </v-col>
                        <v-col cols="12">
                            <v-row align="center">
                                <v-col>
                                    <v-divider class="bg-primary-blue border-2"></v-divider>
                                </v-col>
                                <v-col cols="auto">
                                    Próximo atendimento
                                </v-col>
                                <v-col>
                                    <v-divider class="bg-primary-pink border-2"></v-divider>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-switch
                                v-model="add_next_session"
                                color="primary-blue"
                                label="Adicionar próximo atendimento?"
                            ></v-switch>
                        </v-col>
                        <v-col v-if="add_next_session" cols="6">
                            <v-menu
                                ref="menuNextSession"
                                v-model="show_next_session"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        :value="formatDate(next_session)"
                                        label="Data do próximo atendimento"
                                        append-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="[basic_rules.required]"
                                        @input="$event => next_session = formatUsa($event)"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="next_session"
                                    no-title
                                    scrollable
                                    editable
                                    @input="show_datepicker_birthday = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col v-if="add_next_session" cols="6">
                            <v-menu
                                ref="menuTimeNextSession"
                                v-model="show_time_next_session"
                                :close-on-content-click="false"
                                :return-value.sync="hour_next_session"
                                transition="scale-transition"
                                offset-y
                                min-width="300px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="hour_next_session"
                                        label="Hora do próximo atendimento"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        :rules="[basic_rules.required]"
                                    ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="show_time_next_session"
                                    v-model="hour_next_session"
                                    format="24hr"
                                    full-width
                                    @click:minute="$refs.menuTimeNextSession.save(hour_next_session)"
                                />
                            </v-menu>
                        </v-col>
                        <v-col v-if="add_next_session" cols="12">
                            <v-switch
                                v-model="next_session_mounted"
                                color="primary-blue"
                                label="Próximo atendimento estruturado?"
                            ></v-switch>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-row no-gutters justify="space-between">
                    <v-col cols="auto">
                        <v-btn :disabled="loading" :loading="loading" color="secondary" outlined dark elevation="0" @click="close"><v-icon left>mdi-arrow-u-left-top</v-icon> Voltar</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn v-if="!isStarter" :disabled="loading" color="primary" outlined elevation="0" @click="show_medical_record = true" class="mr-2" id="tour-dialog-medical-record-btn">
                            <v-icon left>mdi-clipboard-text</v-icon> Prontuário
                        </v-btn>
                        <v-tooltip bottom v-if="isStarter">
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on" class="d-inline-block">
                                    <v-btn disabled color="primary" outlined elevation="0" class="mr-2" id="tour-dialog-medical-record-btn">
                                        <v-icon left>mdi-clipboard-text</v-icon> Prontuário
                                        <v-icon right small>mdi-lock</v-icon>
                                    </v-btn>
                                </span>
                            </template>
                            <span>Recurso Premium</span>
                        </v-tooltip>
                        <v-btn :disabled="loading" :loading="loading" color="primary" dark elevation="0" @click="save">Salvar <v-icon right>mdi-check-bold</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
            <v-dialog v-model="show_confirmation_free_session" max-width="500px">
                <v-card class="pa-4">
                    <v-card-title>
                        Atendimento gratuita
                    </v-card-title>
                    <v-card-text>
                        Esse atendimento está com valor <b>R$0,00</b>. Tem certeza que deseja salvar?
                    </v-card-text>
                    <v-card-actions>
                        <v-row no-gutters justify="space-between">
                            <v-col cols="auto">
                                <v-btn :disabled="loading_confirmation" :loading="loading_confirmation" dark color="primary-pink" elevation="0" @click="closeConfirmation"><v-icon left>mdi-close-thick</v-icon> Cancelar</v-btn>
                            </v-col>
                            <v-col cols="auto">
                                <v-btn :disabled="loading_confirmation" :loading="loading_confirmation" dark color="primary-blue" elevation="0" @click="createSession">Salvar <v-icon right>mdi-check-bold</v-icon></v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="show_alert_one_more_session" max-width="500px">
                <v-card class="pa-4">
                    <v-card-title>
                        Saldo acabando!
                    </v-card-title>
                    <v-card-text>
                        ATENÇÃO!!! {{ no_more_session ? 'O saldo disponível de' : '' }} {{ customer?.name }} {{ no_more_session ? 'não é suficiente para' : 'possui saldo para somente' }} mais um atendimento.
                    </v-card-text>
                    <v-card-actions>
                        <v-row no-gutters justify="space-between">
                            <v-col cols="auto">
                                <v-btn dark color="primary-pink" elevation="0" @click="finish"><v-icon left>mdi-check</v-icon> Ok</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>

        <DialogMedicalRecord 
            v-if="sessionData"
            v-model="show_medical_record" 
            :sessionData="sessionData" 
        />
    </v-dialog>
</template>

<script>
import dayjs from "dayjs";
dayjs.extend(require('dayjs/plugin/customParseFormat'));
import { mapActions } from 'vuex';
import * as types from '../../../utils/store/mutations-types';
import DialogMedicalRecord from './DialogMedicalRecord.vue';

export default {
    components: {
        DialogMedicalRecord
    },
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false
        },
        customerData: {
            type: Object,
            required: false,
            default: null
        },
        sessionData: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            show: this.value,
            basic_rules: {
                required: value => !!value || "Informação obrigatória"
            },
            show_datepicker_date: false,
            loading: false,
            error_message: null,
            success_message: null,
            show_timepicker: false,
            show_time_next_session: false,
            show_next_session: false,
            customer: null,
            session_date: null,
            hour_session: null,
            hour_next_session: null,
            next_session: null,
            comments: null,
            private_note: null,
            attended: true,
            session_duration: null,
            session_value: null,
            session_record: false,
            add_next_session: true,
            show_confirmation_free_session: false,
            show_alert_one_more_session: false,
            no_more_session: false,
            loading_confirmation: false,
            next_session_mounted: false,
            session_info: null,
            customer_name: null,
            show_medical_record: false
        };
    },
    watch: {
        value() {
            this.show = this.value;
        },
        show() {
            if (!this.show) {
                this.$emit("close");

                this.show_datepicker_date = false;
                this.loading = false;
                this.error_message = null;
                this.success_message = null;
                this.show_timepicker = false;
                this.show_time_next_session = false;
                this.show_next_session = false;
                this.customer = null;
                this.session_date = null;
                this.hour_session = null;
                this.hour_next_session = null;
                this.next_session = null;
                this.comments = null;
                this.private_note = null;
                this.attended = false;
                this.session_duration = null;
                this.session_value = null;
                this.session_record = false;
                this.add_next_session = false;
                this.show_confirmation_free_session = false;
                this.show_alert_one_more_session = false;
                this.no_more_session = false;
                this.loading_confirmation = false;
                this.next_session_mounted = false;
                this.session_info = null;
                this.customer_name = null;
                this.show_medical_record = false;
            }

            this.error_message = null;
            this.success_message = null;
            this.$emit("input", this.show);
        },
        sessionData() {
            if (this.sessionData) {
                this.customer = this.sessionData.customer ? this.sessionData.customer : this.customerData;
                this.customer_name = this.customer.name;
                this.session_date = dayjs(this.sessionData.session_date).format("YYYY-MM-DD");
                this.hour_session = dayjs(this.sessionData.session_date).format("HH:mm");
                this.session_duration = this.sessionData.session_duration;
                this.session_value = this.sessionData.session_value / 100;
                this.attended = true;
                this.comments = this.sessionData.comments;
                this.private_note = this.sessionData.private_note;

                this.fillNextSession();
            }
        },
        attended() {
            if (!this.attended) {
                this.session_duration = 0;
            } else {
                if (this.sessionData) {
                    this.session_duration = this.sessionData.session_duration;
                }
            }
        }
    },
    computed: {
        isStarter() {
            return this.$store.state.auth.user?.access_profile_slug === 'starter';
        }
    },
    mounted() {
        window.$dialogConfirmSession = this;
    },
    beforeDestroy() {
        if (window.$dialogConfirmSession === this) {
            window.$dialogConfirmSession = null;
        }
    },
    methods: {
        ...mapActions("sessions", ["ActionDoCreateSession", "ActionDoUpdateSession", "ActionDoGetContractByService"]),
        formatDate(date) {
            return date ? dayjs(date).format("DD/MM/YYYY") : null;
        },
        formatUsa(date) {
            if (date) {
                if (date.length === 8) {
                    return dayjs(date, 'DDMMYYYY').format('YYYY-MM-DD');
                } else if (date.length === 10) {
                    return dayjs(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
                }
            }

            return null;
        },
        fillNextSession() {
            this.ActionDoGetContractByService({
                customer_id: this.sessionData.customer.id,
                service_id: this.sessionData.service_id
            }).then(response => {
                if (response) {
                    this.hour_next_session = response.hour_attendance;
                    this.add_next_session = true;

                    switch (response.attendance_frequency) {
                        case "S":
                            this.next_session = dayjs(this.session_date).add(7, "day").format("YYYY-MM-DD");
                            break;
                        case "Q":
                            this.next_session = dayjs(this.session_date).add(2, "week").format("YYYY-MM-DD");
                            break;
                        case "M":
                            this.next_session = dayjs(this.session_date).add(4, "week").format("YYYY-MM-DD");
                            break;
                    }
                } else {
                    this.add_next_session = false;
                }
            }).catch(error => {
                // If no contract found (404/422), just disable next session silently — this is expected for standalone sessions.
                const status = error?.response?.status;
                if (status === 404 || status === 422) {
                    this.add_next_session = false;
                } else {
                    console.error(error);
                    this.error_message = "Erro ao buscar contrato";
                }
            });
        },
        close() {
            this.$refs.formSession.reset();
            this.show = false;
        },
        save() {
            this.loading = true;
            this.error_message = null;
            this.success_message = null;

            if (this.$refs.formSession.validate()) {
                let session_value = typeof this.session_value === 'number' ? this.session_value * 100 : parseInt(this.session_value.toString().replace(/[^0-9]+/g, ""));

                if (session_value > 0) {
                    this.createSession();
                } else {
                    this.show_confirmation_free_session = true;
                }
            } else {
                this.loading = false;
            }
        },
        createSession() {
            this.loading_confirmation = true;
            let session_value = typeof this.session_value === 'number' ? this.session_value * 100 : parseInt(this.session_value.toString().replace(/[^0-9]+/g, ""))

            this.ActionDoUpdateSession({
                session_id: this.sessionData.id,
                service_id: this.sessionData.service_id,
                customer_id: this.customer.id,
                session_date: this.session_date + ' ' + this.hour_session,
                attended: this.attended,
                comments: this.comments,
                private_note: this.private_note,
                session_value: session_value,
                session_duration: this.session_duration,
                session_record: this.session_record,
                finished: true,
                mounted: this.sessionData.mounted
            }).then(response => {
                if (this.add_next_session) {
                    this.ActionDoCreateSession({
                        customer_id: this.customer.id,
                        service_id: this.sessionData.service_id,
                        session_date: this.next_session + ' ' + this.hour_next_session,
                        attended: false,
                        comments: null,
                        private_note: null,
                        session_record: false,
                        finished: false,
                        mounted: this.next_session_mounted
                    }).then(next_response => {
                        if (next_response.session) {
                            if ((this.customer.balance - session_value) <= session_value) {
                                this.show_alert_one_more_session = true;
                                this.no_more_session = (this.customer.balance - session_value) < session_value;
                            } else {
                                this.finish();
                            }
                        } else {
                            this.error_message = "Houve um erro ao confirmar o atendimento";
                            this.show_confirmation_free_session = false;
                            this.loading_confirmation = false;
                            this.loading = false;
                        }
                    });
                } else {
                    if (response.session_id) {
                        if ((this.customer.balance - session_value) <= session_value) {
                            this.show_alert_one_more_session = true;
                            this.no_more_session = (this.customer.balance - session_value) < session_value;
                        } else {
                            this.finish();
                        }
                    } else {
                        this.error_message = "Houve um erro ao registrar o atendimento";
                        this.show_confirmation_free_session = false;
                        this.loading_confirmation = false;
                        this.loading = false;
                    }
                }                
            }).catch(error => {
                console.error(error);
                this.error_message = error.response.data;
                this.show_confirmation_free_session = false;
                this.loading_confirmation = false;
                this.loading = false;
            });
        },
        finish() {
            this.$store.commit("utils/" + types.UPDATE_REFRESH);
            this.show_alert_one_more_session = false;
            this.success_message = "Atendimento registrada com sucesso";
            this.$refs.formSession.reset();
            this.loading = false;
            this.$emit("created");
            this.show = false;
        },
        closeConfirmation() {
            this.loading = false;
            this.show_confirmation_free_session = false;
        }
    }
};
</script>
